export default __webpack_public_path__ + "static/image7-d6e34066058e98439650977d2b7f63fd.gif";